import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { makeZodI18nMap } from 'zod-i18n-map';

import zodErrorsNL from '@/lib/lang/zod/nl.json';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const NAMESPACES = [
    'admin',
    'applications',
    'common',
    'elektra',
    'inspection-plans',
    'navigation',
    'projects',
    'quotes',
    're-inspections',
    'schedules',
    'translation',
    'validation',
] as const;

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)

    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'nl',
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        ns: NAMESPACES,
        load: 'all',
        defaultNS: 'common',
        partialBundledLanguages: true,
        resources: {
            nl: {
                zod: zodErrorsNL,
            },
        },
    })
    .then(() => {
        z.setErrorMap(makeZodI18nMap({ ns: 'zod' }));
    });

export default i18n;
